import React from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

import ProFeaturePlaceholder
  from 'components/common/ProFeaturePlaceholder';

import './CustomAvatarStyleItem.css';


const CustomAvatarStyleItem = ({ me, item, active, onClick, avatarType }) => (
  <Translation>
    {(t) => (
      <ProFeaturePlaceholder
        proLabel={item.isPro}
        lockBackground="rgba(255, 255, 255, 0)"
        locked={
          me &&
          me.subscription &&
          !me.subscription.ff_custom_avatar &&
          item.isPro
        }
        placeholderContent={
          <div>
            {t("This custom avatar is available on the PRO plan.")}
          </div>
        }
      >
        <div
          className={`custom-avatar-style-item__component${active ? ' active': ''}`}
          onClick={onClick}
          role="button"
          tabIndex={-1}
        >
          <div className={`custom-avatar-wrapper ${avatarType}`} />
        </div>
      </ProFeaturePlaceholder>
    )}
  </Translation>
);

CustomAvatarStyleItem.propTypes = {
  onClick: PropTypes.func.isRequired,
  avatarType: PropTypes.string.isRequired,
  active: PropTypes.bool,
  me: PropTypes.object.isRequired,
  item: PropTypes.object.isRequired,
};

CustomAvatarStyleItem.defaultProps = {
  active: null,
};

export default CustomAvatarStyleItem;
